import { useEffect, useMemo, useState } from 'react';
import { checkHasSections, getOptionsWithSection } from '../BaseSelect.utils';
export var useOptions = _ref => {
  var {
    options: optionsList,
    filterOptions,
    query,
    shouldShowPresetOptions
  } = _ref;
  var hasSections = checkHasSections(optionsList);
  var updatedOptions = useMemo(() => hasSections ? getOptionsWithSection(optionsList) : optionsList, [hasSections, optionsList]);
  var [options, setOptions] = useState(updatedOptions);
  var [filteredOptions, setFilteredOptions] = useState(filterOptions(options, query));
  useEffect(() => {
    setFilteredOptions(filterOptions(options, query)); // eslint-disable-next-line react-hooks/exhaustive-deps -- `filterOptions` is an external function so we can skip adding it to the dependency list.
  }, [options, query]); // Makes sure we get the latest options list.

  useEffect(() => {
    setOptions(updatedOptions);
  }, [updatedOptions]);

  var clearOptions = () => {
    if (shouldShowPresetOptions) return;
    setOptions([]);
  };

  useEffect(() => {
    if (shouldShowPresetOptions && filteredOptions.length === 0 && !query) setFilteredOptions(options);
  }, [options, shouldShowPresetOptions, filteredOptions, query]);
  return {
    hasSections,
    options,
    filteredOptions,
    clearOptions
  };
};
//# sourceMappingURL=useOptions.js.map